import React, { FC, ReactElement } from 'react';
import { FileDrop } from 'react-file-drop';
import './DragDropContainer.scss';

const fileTypes: string[] = ['JPEG', 'PNG', 'GIF'];

interface DragDropProps {
  handleChange: (ev: any) => void;
  children?: ReactElement | any;
  customClassName?: string;
}

const DragDropContainer: FC<DragDropProps> = ({
  handleChange,
  customClassName,
  children,
}) => {
  return (
    <FileDrop
      onDrop={(files, event) => handleChange(files)}
      className={customClassName}
    >
      {children}
    </FileDrop>
  );
};

export default DragDropContainer;
